import type { ShiftProductionFormPayload } from "../../../shared/shift-production-form/contracts";

const day = 86_400_000;

export function instantToFormTime(value: string | null) {
  if (!value || !Number.isFinite(Date.parse(value))) return "";
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Istanbul",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(new Date(value));
}

export function formTimeToInstant(
  time: string,
  productionDate: string | null,
  after: string | null = null,
) {
  if (!productionDate || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time)) return null;
  const instant = Date.parse(`${productionDate}T${time}:00+03:00`);
  if (!Number.isFinite(instant)) return null;
  const result = after && instant < Date.parse(after) ? instant + day : instant;
  return new Date(result).toISOString();
}

// Rebase visible times when the date changes; end times crossing midnight belong to the next day.
export function alignFormTimes(
  payload: ShiftProductionFormPayload,
): ShiftProductionFormPayload {
  if (!payload.productionDate) return payload;
  const align = (value: string | null, after: string | null = null) =>
    formTimeToInstant(instantToFormTime(value), payload.productionDate, after);
  return {
    ...payload,
    products: payload.products.map((product) => {
      const machineStartedAt = align(product.machineStartedAt);
      const postChangeMachineStartedAt = align(
        product.postChangeMachineStartedAt,
      );
      return {
        ...product,
        machineStartedAt,
        firstProductAt: align(product.firstProductAt, machineStartedAt),
        postChangeMachineStartedAt,
        postChangeFirstProductAt: align(
          product.postChangeFirstProductAt,
          postChangeMachineStartedAt,
        ),
        downtimes: product.downtimes.map((item) => {
          const startedAt = align(item.startedAt);
          return {
            ...item,
            startedAt,
            endedAt: align(item.endedAt, startedAt),
          };
        }),
      };
    }),
  };
}
